import { type FC } from 'react';

import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@wwe-portal/ui/components/tooltip';
import { useTooltipOpen } from '@wwe-portal/ui/components/tooltip/use-tooltip';

import { cn } from '@wwe-portal/ui/lib/lib';
import { OfferTimeCountDown } from '../component/offer-time-countdown';

export const Header: FC<{
  title: string;
  endDate?: string | Date | number;
  isAggregate?: boolean;
}> = ({ title, endDate, isAggregate }) => {
  const { open, onOpenChange, trigger } = useTooltipOpen();
  const displayTitle = isAggregate ? 'AGGREGATE REWARDS' : title;

  return (
    <div
      className={cn('bg-offer-review-body-modal relative h-[38px] bg-cover')}
    >
      {endDate ? (
        <div className="absolute -top-9 left-0">
          <OfferTimeCountDown endDate={endDate} />
        </div>
      ) : null}
      <div className="absolute inset-0">
        <Tooltip onOpenChange={onOpenChange} open={open}>
          <TooltipTrigger asChild onClick={trigger}>
            <div
              className="text-yellow800 font-poppins flex h-full w-full items-center justify-center px-2 text-center text-base font-semibold leading-[18px]"
              title={displayTitle}
            >
              <span className="truncate">{displayTitle}</span>
            </div>
          </TooltipTrigger>
          <TooltipPortal>
            <TooltipContent
              align="center"
              className="max-w-[calc(100vw-64px)]"
              collisionPadding={32}
            >
              <div className="text-wrap">{displayTitle}</div>
              <TooltipArrow />
            </TooltipContent>
          </TooltipPortal>
        </Tooltip>
      </div>
    </div>
  );
};
